module.exports = __webpack_public_path__ + "img/Airbnb-Productivity-Move-Body-Workout-Calendar.bdd8f1aa.png";